import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat); // need this because we receive non-standard date strings from some apis
dayjs.extend(isSameOrBefore);

export const formatDate = (formatString, date = new Date()) => dayjs(date).format(formatString);
export const parseDate = (dateToParse, formatString) => dayjs(dateToParse, formatString).toDate();
export const addDaysToDateAndFormat = (originalDate, daysToAdd, formatString = 'MMM DD, YYYY') =>
  dayjs(originalDate).add(daysToAdd, 'day').format(formatString);
export const isTodayWithinNDaysAfterDate = (originalDate, nDays) => dayjs().isSameOrBefore(dayjs(originalDate).add(nDays, 'day'));
